import { createAction } from '@reduxjs/toolkit';

export const getConfigsApi = createAction('getConfigsApi');
